import classNames from "classnames/bind";
import styles from './FormRegister.module.css';
import HeaderRegister from "../HeaderRegister";
import FormItem from "../../InfoUser/ChangePassword/FormItem/FormItem";
import Button from "../../../components/Button/Button";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import InputText from "./InputText";
import { useStoreContext } from "../../../hooks/useStoreContext";
import { actions } from "../../../store";
import { isValidateConfirm, isValidateUserName, isValidatorEmail } from "../../../utils";
import { SelectBox, SelectBoxItem, Toast } from "../../../components";
import axios from "axios";
import axiosClient from "../../../services/axiosClient";
const cx = classNames.bind(styles);

function FormRegister({ getError }) {
    const [state, dispatch] = useStoreContext()
    const [name, setName] = useState(state.dataUserRegister.name);
    const [userName, setUserName] = useState(state.dataUserRegister.username);
    const [email, setEmail] = useState(state.dataUserRegister.email);
    const [companyName, setCompanyName] = useState();
    const [error, setError] = useState(false);
    const [companies, setCompanies] = useState()
    const navigate = useNavigate()
    const company = sessionStorage.getItem('company_code')
    useEffect(() => {
        const getCompany = async () => {
            try {
                const res = await axiosClient.get(`company/get-list-company/`)
                setCompanies(res);
            } catch (error) {
                Toast.open('Lấy danh sách công ty không thánh công', 'danger')
            }
        }
        if (company === 'DEFAULT') {
            getCompany()
        } else {
            setCompanyName(company);
        }
        // eslint-disable-next-line
    }, [])

    const handleChangeName = (data) => {
        setName(data)
    }

    const handleChangeUserName = (data) => {
        setUserName(data)
    }

    const handleChangeEmail = (data) => {
        setEmail(data)
    }

    const onChangeCompany = (data) => {
        if (data === 'all') {
            setError(true)
        } else {
            setError(false)
            setCompanyName(data)
        }
    }


    const handleSubmit = (e) => {
        e.preventDefault()
        if (userName.trim().length === 0 || email.trim().length === 0 || name.trim().length === 0) {
            Toast.open('Vui lòng nhập đúng tất cả các trường', 'danger')
        } else if (isValidateUserName(userName) && isValidatorEmail(email) && companyName !== 'all') {
            const getCode = async () => {
                try {
                    const res = await axiosClient.post(`userManagement/post-add-userManagement/`, {
                        name: name,
                        username: userName,
                        email: email,
                        company_code: companyName,
                    })
                    navigate(-1)
                    return res
                } catch (error) {
                    if (error.response.data.username && error.response.data.email) {
                        getError('Tên đăng nhập Hoặc Email của bạn không hợp lệ')
                    } else if (error.response.data.username) {
                        getError(error.response.data.username[0])
                    } else if (error.response.data.email) {
                        getError(error.response.data.email[0])
                    } else if (!companyName || companyName === 'all') {
                        getError('Vui lòng chọn công ty')
                    } else (
                        getError('Đăng ký không thành công')
                    )
                }
            }
            getCode()
        }
    }

    return (
        <>
            <HeaderRegister backTo={'/admin/user'} />
            <form className={cx('register-form')} onSubmit={e => handleSubmit(e)}>
                <InputText
                    title={'Tên người dùng'}
                    row
                    register
                    value={name}
                    name={'NAME'}
                    placeholder={'Nhập'}
                    onChange={handleChangeName}
                />
                <InputText
                    title={'Tên đăng nhập'}
                    row
                    register
                    value={userName}
                    name={'USERNAME'}
                    placeholder={'Nhập'}
                    onChange={handleChangeUserName}
                />
                <InputText
                    title={'Email'}
                    row
                    register
                    value={email}
                    name={"EMAIL"}
                    placeholder={'Nhập'}
                    onChange={handleChangeEmail}
                />
                {company === 'DEFAULT' && (
                    <div className={cx('select-box')}>
                        <label className={cx("title")}>Công ty trực thuộc</label>
                        <button className={cx('input-textbox', 'select-box-item')} onClick={e => e.preventDefault()}>
                            <SelectBox
                                style={{ paddingTop: 8 }}
                                onChange={onChangeCompany}
                                required={error}
                            >
                                {companies && companies.map((item, index) => {
                                    return (
                                        <SelectBoxItem key={index} label={item.NAME} value={item.CODE} />
                                    )
                                })}
                            </SelectBox>
                        </button>
                    </div>
                )}
                <button className={cx('button-change')} type={'submit'}>
                    <Button
                        title="Tiếp tục"
                        onClick={handleSubmit}
                    />
                </button>
            </form>
        </>
    )
}
export default FormRegister